import ajax from './Ajax';

const APP = 'Vendor Payments';

export default (e)=>{
  return ajax.post('applicationError',{applicationName:APP,link:window.location.href,...e});
};



// WEBPACK FOOTER //
// ./src/utils/errorReport.js